export default __webpack_public_path__ + "static/media/blog-9-4.de736e0b.jpg";